module.exports = __webpack_public_path__ + "img/fridge.b7060d77.svg";